// branch containers
import BranchAccidentInfoStepContainer from '../BranchAccidentInfoStepContainer/BranchAccidentInfoStepContainer';
import BranchBundlesStepContainer from '../BranchBundlesStepContainer/BranchBundlesStepContainer';
import BranchCreateStepContainer from '../BranchCreateStepContainer/BranchCreateStepContainer';
import BranchDocumentsStepContainer from '../BranchDocumentsStepContainer/BranchDocumentsStepContainer';
import BranchGasStepContainer from '../BranchGasStepContainer/BranchGasStepContainer';
import BranchGeneralInfoStepContainer from '../BranchGeneralInfoStepContainer/BranchGeneralInfoStepContainer';
import BranchRequirementsStepContainer from '../BranchRequirementsStepContainer/BranchRequirementsStepContainer';
import BranchTemplateStepContainer from '../BranchTemplateStepContainer/BranchTemplateStepContainer';

// branch events
import showBranchGeneratorEvent from '../../events/showGenerator.event.branch';
import showBranchSelectEvent from '../../events/showSelect.event.branch';

// insurancePolicy containers
import BranchInsurancePolicyStepContainer from '../../../insurancePolicy/containers/BranchInsurancePolicyStepContainer/BranchInsurancePolicyStepContainer';

// components
import Flow from '@drivesally/sally-ui/lib/components/Flow/Flow';

// event HOCs
import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

// local constants
import DEFAULT_STATE from './constants/defaultState.constant';

// notify
import notify from '@drivesally/sally-ui/lib/libs/notify';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

class BranchGeneratorContainer extends Component {
  static propTypes = {
    branches: PropTypes.array,
    subscribe: PropTypes.func,
  };

  state = {...DEFAULT_STATE};

  componentDidMount() {
    this.props.subscribe(showBranchGeneratorEvent.subscribe(this.show));
  }

  show = () => {
    const {minimized} = this.state;
    this.setState(
      minimized
        ? {visible: true, minimized: false}
        : {...DEFAULT_STATE, visible: true}
    );
  };

  close = (ignoreDisabled = false) => {
    const {visible, disabled, done} = this.state;
    if (!visible || (disabled && !ignoreDisabled)) return;

    const state = {visible: false, minimized: false};

    if (!done) return this.setState(state);

    notify({
      id: 'closeBranchCreationModal',
      title: 'Warning',
      icon: undefined,
      content:
        'Are you sure you want to close this window? All progress will be lost.',
      primary: {
        label: 'Cancel',
        onClick: () => null,
      },
      secondary: {
        label: 'Close',
        onClick: () => this.setState(state),
      },
    });
  };

  finish = () => {
    this.setState({visible: false, minimized: false});
  };

  minimize = (ignoreDisabled = false) => {
    const {visible, disabled} = this.state;
    if (!visible || (disabled && !ignoreDisabled)) return;
    this.setState({visible: false, minimized: true});
  };

  onStep = (step, ignoreCheck = false) => {
    const {disabled, done, step: currentStep} = this.state;
    const goingBack = step < currentStep;
    if (!ignoreCheck && disabled) return;
    const newDone = step - 1 > done ? step - 1 : done;
    this.setState({step, done: newDone, goingBack});
  };

  onStepReset = (step) => () => this.setState({step, done: step - 1});

  onStepComplete = (step) => (data = {}, {ignoreDisabled = false} = {}) => {
    const {disabled} = this.state;
    if (!ignoreDisabled && disabled) return;
    this.setState(data);
    this.onStep(step, ignoreDisabled);
  };

  disable = (disabled) => this.setState({disabled});

  flows = () => [
    {title: 'Template'},
    {title: 'General'},
    /*{title: 'Insurance'},*/
    {title: 'GAS', size: 'large'},
    {title: 'Documents', size: 'large'},
    {title: 'Bundles', size: 'large'},
    {title: 'Requirements', size: 'large'},
    {title: 'Accident Info'},
    {title: 'Save'},
  ];

  content = (Content) => {
    const {visible, goingBack, branch, step, done} = this.state;

    const props = {
      branch,
      Container: Content,
      done,
      goingBack,
      onClose: this.close,
      onDisabled: this.disable,
      onFinish: this.finish,
      visible,
      setStepChangeValidator: () => () => true,
    };

    switch (step) {
      case 1:
        return (
          <BranchTemplateStepContainer
            onNext={this.onStepComplete(2)}
            {...props}
          />
        );
      case 2:
        return (
          <BranchGeneralInfoStepContainer
            canEditName
            onBack={this.onStepComplete(1)}
            onNext={this.onStepComplete(3)}
            {...props}
          />
        );
      case 3:
        return (
          <BranchInsurancePolicyStepContainer
            onBack={this.onStepComplete(2)}
            onNext={this.onStepComplete(4)}
            {...props}
          />
        );
      case 4:
        return (
          <BranchGasStepContainer
            onBack={this.onStepComplete(3)}
            onNext={this.onStepComplete(5)}
            {...props}
          />
        );
      case 5:
        return (
          <BranchDocumentsStepContainer
            onBack={this.onStepComplete(4)}
            onNext={this.onStepComplete(6)}
            {...props}
          />
        );
      case 6:
        return (
          <BranchBundlesStepContainer
            onBack={this.onStepComplete(5)}
            onNext={this.onStepComplete(7)}
            {...props}
          />
        );
      case 7:
        return (
          <BranchRequirementsStepContainer
            onBack={this.onStepComplete(6)}
            onNext={this.onStepComplete(8)}
            {...props}
          />
        );
      case 8:
        return (
          <BranchAccidentInfoStepContainer
            onBack={this.onStepComplete(7)}
            onNext={this.onStepComplete(9)}
            {...props}
          />
        );
      case 9:
        return (
          <BranchCreateStepContainer
            onBack={this.onStepComplete(8)}
            {...props}
          />
        );
      default:
        return <Content>You even know what you're doing here?</Content>;
    }
  };

  selectBranch = () => {
    showBranchSelectEvent.publish();
  };

  headerActions = () => {
    const {step, done} = this.state;
    return [
      ![1, 8].includes(step) && {
        icon: 'sharealt',
        tooltip: 'Copy from branch',
        onClick: this.selectBranch,
      },
      !!done && {
        icon: 'minus',
        tooltip: 'Minimize',
        onClick: this.minimize,
      },
    ].filter((action) => !!action);
  };

  render() {
    const {visible, step, done, hide} = this.state;
    const flows = this.flows();
    const flow = flows[step - 1];
    return (
      <Flow
        flows={flows}
        title="New Branch"
        subtitle={flow.title}
        visible={visible && !hide}
        onClose={this.close}
        step={step}
        done={done}
        size={flow.size || 'medium'}
        onStep={() => {}}
        headerActions={this.headerActions()}
      >
        {this.content}
      </Flow>
    );
  }
}

export default subscriptionHOC(BranchGeneratorContainer);
